module.exports = __webpack_public_path__ + "static/media/client-icon.c31fb3dd.svg";